/**
 * Created by Lp on 22/06/2016. Copyright Transoft Ltda.
 */
(function(){
    'use strict';

    angular.module('completeAir')
        .directive('autoCompleteSegmentOrigin', ['$rootScope', 'stretchAssistantService','linkService', autoCompleteSegmentOrigin])
        .directive('autoCompleteSegmentDestiny', ['$rootScope', 'stretchAssistantService','linkService', autoCompleteSegmentDestiny]);

    function autoCompleteSegmentOrigin($rootScope, stretchAssistantService,linkService){
        var directive = {
            restrict: 'AC',
            link: linkFunc
        }
        return directive;

        function linkFunc(scope, element, attrs){
            var stretchAssistants = [],
                responseStretchAssistants = [];

            element.autocomplete({
                minLength: 1,
                delay: 200,
                source: function(request, response){

                    var search = request.term;

                    if(search != ""){
                        stretchAssistantService.search(search)
                            .then(function(res){
                                responseStretchAssistants = [];
                                if(res.data._embedded) {
                                    responseStretchAssistants = ignoredRepeat(res.data._embedded.stretchAssistants);
                                    stretchAssistants = dataAutoComplete(responseStretchAssistants);
                                    response(stretchAssistants);
                                }else{
                                    $rootScope.segmentAssistantTmp = [];
                                    response([]);
                                }
                            });
                    }
                },
                focus: function(){

                },
                select: function(event, ui){
                    var posValue = stretchAssistants.indexOf(ui.item.value),
                        objectStretchAssistant = responseStretchAssistants[posValue];

                    /* modificado para usar en connectionItinerary para llenar origen y destino*/
                    if(scope.itineraryConnection != undefined){
                        scope.itineraryConnection.origin =  objectStretchAssistant.originAirport.iataCode;
                        scope.itineraryConnection.originId =  objectStretchAssistant.originAirport.rId;
                    }else{
                        $rootScope.segmentAssistantTmp = objectStretchAssistant;
                    }
                    //scope.updatePoint(attrs.point, objectStretchAssistant,false);
                },
                change: function(){

                }
            });

            function ignoredRepeat(stretchAssistants){
                var tmp = [];
                var equal = 0;
                angular.forEach(stretchAssistants,function(val){
                    if(equal!==linkService.getLinkId(val._embedded.airports[0]._links.self.href)){
                        tmp.push(val);
                        equal = linkService.getLinkId(val._embedded.airports[0]._links.self.href);
                    }
                });
                return tmp;
            }

            function dataAutoComplete(stretchAssistants){
                var res = [];
                angular.forEach(stretchAssistants, function(stretchAssistant){
                    /*var dataName = stretchAssistant.originAirport.locality.region.initials +
                        "(" + stretchAssistant.originAirport.iataCode + ")";*/
                    var dataName = stretchAssistant._embedded.airports[0].iata;
                    res.push(dataName)
                });
                return res;
            }
        }
    }

    function autoCompleteSegmentDestiny($rootScope, stretchAssistantService){
        var directive = {
            restrict: 'AC',
            link: linkFunc
        }
        return directive;

        function linkFunc(scope, element, attrs){
            var stretchAssistants = [],
                responseStretchAssistants = [];

            element.autocomplete({
                minLength: 1,
                delay: 200,
                source: function(request, response){
                    var search = request.term;
                    var originId = 0;
                    /* modificado para usar en connectionItinerary para llenar origen y destino*/
                    if(scope.itineraryConnection != undefined){
                        originId = scope.itineraryConnection.originId;
                    }else{
                        originId = scope.routeObjectA.stretchRoutes[scope.routeObjectA.stretchRoutes.length-1].originId;
                    }

                    if(search != ""){
                        stretchAssistantService.searchDestiny(originId, search)
                            .then(function(res){
                                responseStretchAssistants = [];
                                if(res.data._embedded) {
                                    responseStretchAssistants = res.data._embedded.stretchAssistants;
                                    stretchAssistants = dataAutoComplete(responseStretchAssistants);
                                    response(stretchAssistants);
                                }else{
                                    $rootScope.segmentAssistantTmp = [];
                                    response([]);
                                }
                            });
                    }
                },
                close: function( event, ui ){

                },
                focus: function(){

                },
                select: function(event, ui){
                    var posValue = stretchAssistants.indexOf(ui.item.value),
                        objectStretchAssistant = responseStretchAssistants[posValue];
                    /* modificado para usar en connectionItinerary para llenar origen y destino*/
                    if(scope.itineraryConnection != undefined){
                        scope.itineraryConnection.destiny =  objectStretchAssistant.destinyAirport.iataCode;
                        scope.itineraryConnection.destinyId =  objectStretchAssistant.destinyAirport.rId;
                    }else{
                        $rootScope.segmentAssistantTmp = objectStretchAssistant;
                    }
                },
                change: function(){

                }
            });

            function dataAutoComplete(stretchAssistants){
                var res = [];
                angular.forEach(stretchAssistants, function(stretchAssistant){
                    /*var dataName = stretchAssistant.destinyAirport.locality.region.initials +
                        "(" + stretchAssistant.destinyAirport.iataCode + ")";*/
                    var dataName = stretchAssistant._embedded.airports[1].iata;
                    res.push(dataName)
                });
                return res;
            }
        }
    }

})();
